import Vue from 'vue';

import pinia from '@/pinia';
import { useAuthStore, useSetupStore } from '@/stores';
import { startTokenKeeper } from '@/utils/tokenKeeper';
// import router from '@/router';

const initialize = () => {
    const authStore = useAuthStore(pinia);
    const setupStore = useSetupStore(pinia);

    startTokenKeeper();

    return new Promise((resolve, reject) => {
        if (authStore.token) {
            setupStore
                .fetchSetup()
                .then(resolve)
                .catch(err => {
                    authStore.signout();
                    reject(err);
                });

        } else {
            setupStore.checkHealth().finally(() => {
                Vue.nextTick(() => {
                    // router.push({ path: '/' });
                    setupStore.updateLoadedState(true);
                    resolve();
                });
            });
        }
    });
}

export default initialize;
